import { render, staticRenderFns } from "./consent-table.vue?vue&type=template&id=362cbcec"
import script from "./consent-table.vue?vue&type=script&lang=js"
export * from "./consent-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports